import { render, staticRenderFns } from "./CoverSummary.vue?vue&type=template&id=4d011167&scoped=true"
import script from "./CoverSummary.vue?vue&type=script&lang=js"
export * from "./CoverSummary.vue?vue&type=script&lang=js"
import style0 from "./CoverSummary.vue?vue&type=style&index=0&id=4d011167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d011167",
  null
  
)

export default component.exports